<script>
import { mapState, mapActions } from 'pinia';
import { useModalStore } from './../../../stores/modal';

export default {
	computed: {
		...mapState(useModalStore, [
			'isModalOpen',
			'config'
		]),
		
		layerClass() {
			return [
				this.config('classLayer'),
				{
					[this.config('classLayerActive')] : this.isModalOpen
				}
			];
		}
	},
	methods: {
		...mapActions(useModalStore, [
			'closeModal'
		])
	}
};
</script>
<template>
	<div class="modal-layer" :class="layerClass" @click="closeModal"></div>
</template>
